import { createTheme as createMuiTheme, Theme } from '@material-ui/core/styles';
import * as Colors from '@material-ui/core/colors';
import { PaletteType } from '@material-ui/core';

const createTheme = (type: PaletteType = 'light'): Theme =>
  createMuiTheme({
    palette: {
      primary: Colors.deepPurple,
      secondary: Colors.pink,
      type,
    },
    overrides: {
      MuiButton: {
        root: {
          textTransform: 'none',
        },
      },
      // Pin text-size-adjust so iOS Safari/WebKit does not auto-inflate
      // ("font boost") text inside wide, horizontally-scrollable tables.
      // Boosting assigns a different multiplier per cell based on block
      // width and recomputes on every relayout, which makes cell fonts —
      // and therefore measured virtual-row heights — twitch while scrolling
      // on mobile. '100%' disables the auto-inflation while preserving the
      // user's pinch-to-zoom (unlike 'none').
      MuiCssBaseline: {
        '@global': {
          html: {
            WebkitTextSizeAdjust: '100%',
            textSizeAdjust: '100%',
          },
        },
      },
    },
  });

export default createTheme;
